import whiteInsideCheck from "../assets/svg/white_inside_check.svg";
import { useSpring, animated } from "@react-spring/web";
import { useEffect } from "react";

export function MessagePaymentApproved() {
  const propsUseSpring = useSpring({
    from: { width: "0%" },
    to: { width: "100%" },
    config: { duration: 5000 },
  });

  useEffect(() => {
    setTimeout(() => {
      window.location.href = "/";
    }, 5000);
  }, []);

  return (
    <div className="style-container-loading-page">
      <div className="d-flex flex-column align-items-center text-center">
        <img
          src={whiteInsideCheck}
          alt="check"
          className="style-size-image-payment-approved"
        />

        <div className="style-empty-row-payment-approved"></div>

        <p className="text-light fw-bold style-fs-text-payment-approved">
          Seu pagamento foi confirmado com sucesso. <br />
          Agradecemos imensamente pela sua confiança.
        </p>

        <div
          style={{
            marginTop: "3%",
            width: "100%",
            maxWidth: "80%",
            height: "5px",
            background: "transparent",
          }}
        >
          <animated.div
            style={{
              ...propsUseSpring,
              height: "100%",
              background: "#FFF",
              borderRadius: "50px",
            }}
          />
        </div>
      </div>
    </div>
  );
}
